import { useState } from 'react'
import SplineAvatar from './SplineAvatar'
import { useElevenLabs } from '../hooks/useElevenLabs'

export default function AgentWidget() {
  const { status, mode, transcript, error, start, stop } = useElevenLabs()
  const [hover, setHover] = useState(false)
  const [hoverStop, setHoverStop] = useState(false)

  const isConnected = status === 'connected'
  const isConnecting = status === 'connecting'
  const isSpeaking = mode === 'speaking'
  const isListening = mode === 'listening'

  const statusLabel = {
    idle: 'Haz click para hablar',
    connecting: 'Conectando...',
    connected: isSpeaking ? 'Respondiendo...' : 'Escuchando...',
    error: 'Error — intenta de nuevo',
  }[status]

  const accentColor = isSpeaking ? '#00d4ff' : isListening ? '#ff3cac' : '#7c6af7'

  return (
    <div style={styles.root}>

      {/* ══ SPLINE — fondo completo ══ */}
      <div style={styles.splineLayer}>
        <SplineAvatar mode={mode} />
      </div>

      {/* ══ OVERLAY de gradientes ══ */}
      {/* Gradiente inferior para legibilidad del UI */}
      <div style={styles.gradientBottom} />
      {/* Gradiente lateral izquierdo */}
      <div style={styles.gradientLeft} />
      {/* Vignette general */}
      <div style={styles.vignette} />

      {/* ══ PARTÍCULAS decorativas ══ */}
      <Particles active={isConnected} color={accentColor} />

      {/* ══ NAV top-left ══ */}
      <nav style={styles.nav}>
        <div style={styles.logo}>
          Kerbrum Agency
        </div>
        <div style={{
          ...styles.statusBadge,
          borderColor: isConnected ? `${accentColor}55` : 'rgba(255,255,255,.1)',
          background: isConnected ? `${accentColor}11` : 'rgba(0,0,0,.3)',
        }}>
          <div style={{
            ...styles.statusDot,
            background: isConnected ? accentColor : '#444',
            boxShadow: isConnected ? `0 0 8px ${accentColor}` : 'none',
            animation: isConnected ? 'pulse 1.5s ease-in-out infinite' : 'none',
          }} />
          <span style={{ color: isConnected ? accentColor : 'rgba(255,255,255,.4)', fontSize: '11px', letterSpacing: '.08em' }}>
            {isConnected ? 'EN LÍNEA' : 'OFFLINE'}
          </span>
        </div>
      </nav>

      {/* ══ PANEL izquierdo — info ══ */}
      <div style={styles.leftPanel}>
        <p style={styles.eyebrow}>Asistente con IA</p>
        <h1 style={styles.h1}>
          <span style={{ color: '#00d4ff', fontStyle: 'italic' }}>Kerbot</span>
        </h1>

      </div>

      {/* ══ PANEL inferior — controles ══ */}
      <div style={styles.bottomPanel}>

        {/* Transcript */}
        {/* {transcript && (
          <div style={{
            ...styles.transcript,
            borderColor: transcript.role === 'agent'
              ? 'rgba(0,212,255,.2)' : 'rgba(255,60,172,.2)',
          }}>
            <span style={{
              fontSize: '10px', letterSpacing: '.1em', textTransform: 'uppercase',
              color: transcript.role === 'agent' ? 'rgba(0,212,255,.6)' : 'rgba(255,60,172,.6)',
              display: 'block', marginBottom: '.3rem',
            }}>
              {transcript.role === 'agent' ? '▶ Agente' : '◉ Tú'}
            </span>
            <span style={{ fontSize: '14px', color: 'rgba(220,230,255,.9)', lineHeight: 1.5 }}>
              {transcript.text}
            </span>
          </div>
        )} */}

        {/* Error */}
        {error && (
          <div style={styles.errorBox}>❌ {error}</div>
        )}

        {/* Sound bars + status — izquierda */}
        <div style={styles.controlsRow}>
          <div style={styles.bars}>
            {[12, 22, 30, 18, 24, 14, 20, 10].map((h, i) => (
              <div key={i} style={{
                width: '4px',
                height: `${h}px`,
                borderRadius: '3px',
                background: isSpeaking ? '#00d4ff' : isListening ? '#ff3cac' : 'rgba(255,255,255,.15)',
                transformOrigin: 'bottom',
                animation: isConnected
                  ? `${isSpeaking ? 'barSpk' : 'barLst'} ${.55 + i * .07}s ease-in-out ${i * .07}s infinite`
                  : 'none',
                transition: 'background .4s',
              }} />
            ))}
          </div>
          <span style={{
            fontSize: '12px', letterSpacing: '.06em',
            color: isConnected ? accentColor : 'rgba(255,255,255,.35)',
            textTransform: 'uppercase',
          }}>
            {statusLabel}
          </span>
        </div>

        {/* CTA Button — centrado */}
        <div style={styles.btnRow}>
          {!isConnected ? (
            <button
              onClick={start}
              disabled={isConnecting}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              style={{
                ...styles.btnStart,
                transform: hover && !isConnecting ? 'translateY(-2px) scale(1.04)' : 'none',
                boxShadow: hover && !isConnecting
                  ? '0 0 60px rgba(0,212,255,.6), 0 8px 32px rgba(0,0,0,.4)'
                  : '0 0 30px rgba(0,212,255,.25), 0 4px 20px rgba(0,0,0,.3)',
                opacity: isConnecting ? .6 : 1,
              }}
            >
              {isConnecting ? (
                <>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, animation: 'spinBtn .9s linear infinite' }}>
                    <circle cx="12" cy="12" r="10" stroke="rgba(2,2,20,.4)" strokeWidth="2.5" />
                    <path d="M12 2a10 10 0 0 1 10 10" stroke="#020214" strokeWidth="2.5" strokeLinecap="round" />
                  </svg>
                  Conectando...
                </>
              ) : (
                <>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                    <rect x="9" y="2" width="6" height="13" rx="3" fill="#020214" />
                    <path d="M5 11a7 7 0 0 0 14 0" stroke="#020214" strokeWidth="2" strokeLinecap="round" />
                    <line x1="12" y1="18" x2="12" y2="22" stroke="#020214" strokeWidth="2" strokeLinecap="round" />
                    <line x1="8" y1="22" x2="16" y2="22" stroke="#020214" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                  Habla con Kerbot
                </>
              )}
            </button>
          ) : (
            <button
              onClick={stop}
              onMouseEnter={() => setHoverStop(true)}
              onMouseLeave={() => setHoverStop(false)}
              style={{
                ...styles.btnStop,
                transform: hoverStop ? 'translateY(-2px) scale(1.04)' : 'none',
                boxShadow: hoverStop
                  ? '0 0 40px rgba(255,60,172,.35), 0 6px 24px rgba(0,0,0,.4)'
                  : '0 0 16px rgba(255,60,172,.1), 0 4px 16px rgba(0,0,0,.3)',
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                <path d="M22.67 17.93c-.36-.33-3.03-2.1-3.7-2.36-.69-.27-1.19-.27-1.68.27-.5.54-.96 1.08-1.44 1.32-.47.23-.97.12-1.44-.18-1.7-1.04-4.1-3.44-5.14-5.14-.3-.47-.41-.97-.18-1.44.24-.48.78-.94 1.32-1.44.54-.49.54-.99.27-1.68C10.4 6.61 8.6 3.7 8.07 3.33 7.5 2.92 6.96 3 6.4 3.23c-.9.37-1.74.97-2.45 1.68C2.68 6.18 2 7.53 2 9c0 2.02.8 4.3 2.4 6.6 1.6 2.3 3.6 4.3 5.9 5.9C12.6 23.1 14.88 24 17 24h.08c1.44-.02 2.75-.7 3.99-1.95.7-.7 1.3-1.54 1.67-2.45.23-.56.15-1.1-.07-1.67Z" fill="#ff3cac" />
                <line x1="3" y1="3" x2="21" y2="21" stroke="#ff3cac" strokeWidth="2.2" strokeLinecap="round" />
              </svg>
              Finalizar
            </button>
          )}
        </div>
      </div>

      {/* ══ Anillos cuando habla ══ */}
      {isSpeaking && (
        <div style={styles.ringsContainer}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{
              ...styles.ring,
              borderColor: accentColor,
              animation: `ringExp 1.6s ease-out ${i * .5}s infinite`,
            }} />
          ))}
        </div>
      )}

      {/* ══ Global styles ══ */}
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.3} }
        @keyframes barSpk { 0%,100%{transform:scaleY(.2);opacity:.3} 50%{transform:scaleY(1);opacity:1} }
        @keyframes barLst { 0%,100%{transform:scaleY(.1);opacity:.2} 50%{transform:scaleY(.6);opacity:.7} }
        @keyframes ringExp { 0%{transform:translate(-50%,-50%) scale(.2);opacity:.8} 100%{transform:translate(-50%,-50%) scale(2.5);opacity:0} }
        @keyframes floatUp { 0%{transform:translateY(0);opacity:.7} 100%{transform:translateY(-100vh);opacity:0} }
        @keyframes spinBtn { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  )
}

/* ── Partículas flotantes ─────────────────────── */
function Particles({ active, color }) {
  if (!active) return null
  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 2, overflow: 'hidden' }}>
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} style={{
          position: 'absolute',
          bottom: '-10px',
          left: `${8 + i * 8}%`,
          width: `${2 + Math.random() * 3}px`,
          height: `${2 + Math.random() * 3}px`,
          borderRadius: '50%',
          background: i % 2 === 0 ? color : '#ff3cac',
          opacity: .6,
          animation: `floatUp ${3 + i * .4}s ease-in ${i * .3}s infinite`,
        }} />
      ))}
    </div>
  )
}

/* ── Styles ──────────────────────────────────── */
const styles = {
  root: {
    position: 'fixed', inset: 0,
    background: '#06060e',
    overflow: 'hidden',
    fontFamily: "'Inter', system-ui, sans-serif",
    color: '#e8f0ff',
  },

  // Spline ocupa todo
  splineLayer: {
    position: 'absolute', inset: 0, zIndex: 0,
  },

  // Gradientes encima del Spline para legibilidad
  gradientBottom: {
    position: 'absolute', bottom: 0, left: 0, right: 0,
    height: '55%', zIndex: 1, pointerEvents: 'none',
    background: 'linear-gradient(to top, rgba(6,6,14,.95) 0%, rgba(6,6,14,.7) 40%, transparent 100%)',
  },
  gradientLeft: {
    position: 'absolute', top: 0, left: 0, bottom: 0,
    width: '45%', zIndex: 1, pointerEvents: 'none',
    background: 'linear-gradient(to right, rgba(6,6,14,.85) 0%, rgba(6,6,14,.4) 60%, transparent 100%)',
  },
  vignette: {
    position: 'absolute', inset: 0, zIndex: 1, pointerEvents: 'none',
    background: 'radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,.5) 100%)',
  },

  // Nav
  nav: {
    position: 'absolute', top: 0, left: 0, right: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '1.5rem 2rem', zIndex: 10,
  },
  logo: {
    fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-.03em',
  },
  statusBadge: {
    display: 'flex', alignItems: 'center', gap: '.5rem',
    padding: '.35rem .9rem', borderRadius: '999px',
    border: '1px solid', backdropFilter: 'blur(8px)',
    transition: 'all .5s ease',
  },
  statusDot: {
    width: '7px', height: '7px', borderRadius: '50%',
    transition: 'all .4s ease',
  },

  // Left panel
  leftPanel: {
    position: 'absolute', left: '2.5rem', top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10, maxWidth: '280px',
  },
  eyebrow: {
    fontSize: '.65rem', textTransform: 'uppercase',
    letterSpacing: '.15em', color: 'rgba(0,212,255,.5)',
    marginBottom: '.6rem',
  },
  h1: {
    fontSize: '3rem', fontWeight: 800,
    lineHeight: 1.05, letterSpacing: '-.04em',
    textShadow: '0 2px 30px rgba(0,0,0,.8)',
  },
  description: {
    marginTop: '.8rem', fontSize: '.85rem',
    color: 'rgba(160,180,220,.6)', lineHeight: 1.7,
  },
  features: {
    display: 'flex', flexDirection: 'column', gap: '.5rem',
  },
  featureItem: {
    display: 'flex', alignItems: 'center', gap: '.6rem',
  },

  // Bottom panel
  bottomPanel: {
    position: 'absolute', bottom: 0, left: 0, right: 0,
    padding: '1rem 2rem 2.5rem',
    zIndex: 10,
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.8rem',
  },
  controlsRow: {
    display: 'flex', alignItems: 'center', gap: '1rem',
    flexWrap: 'wrap',
  },
  btnRow: {
    display: 'flex', justifyContent: 'center', width: '100%',
  },
  bars: {
    display: 'flex', alignItems: 'flex-end', gap: '3px', height: '32px',
  },

  // Transcript
  transcript: {
    background: 'rgba(0,0,0,.5)',
    backdropFilter: 'blur(12px)',
    border: '1px solid',
    borderRadius: '14px',
    padding: '.9rem 1.2rem',
    maxWidth: '600px',
  },
  errorBox: {
    background: 'rgba(255,50,50,.1)',
    border: '1px solid rgba(255,50,50,.2)',
    borderRadius: '10px',
    padding: '.7rem 1rem',
    fontSize: '.8rem', color: '#ff7070',
  },

  // Buttons
  btnStart: {
    display: 'flex', alignItems: 'center', gap: '.6rem',
    padding: '.85rem 2.2rem',
    background: 'linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)',
    color: '#020214',
    border: 'none', borderRadius: '50px',
    fontSize: '.95rem', fontWeight: 800,
    letterSpacing: '.04em', cursor: 'pointer',
    transition: 'all .25s cubic-bezier(.34,1.56,.64,1)', whiteSpace: 'nowrap',
  },
  btnStop: {
    display: 'flex', alignItems: 'center', gap: '.6rem',
    padding: '.8rem 2rem',
    background: 'rgba(255,60,172,.08)',
    color: '#ff3cac',
    border: '1px solid rgba(255,60,172,.35)',
    borderRadius: '50px',
    fontSize: '.9rem', fontWeight: 700, cursor: 'pointer',
    transition: 'all .25s cubic-bezier(.34,1.56,.64,1)',
  },

  // Sound rings
  ringsContainer: {
    position: 'fixed',
    bottom: '12%', right: '25%',
    zIndex: 3, pointerEvents: 'none',
  },
  ring: {
    position: 'absolute',
    width: '180px', height: '180px',
    borderRadius: '50%',
    border: '1.5px solid',
    top: '50%', left: '50%',
  },
}
